<template>
  <div data-testid="file-list-config__view">
    <div class="all-height d-flex justify-center">
      <div class="all-width">
        <v-card :loading="loading" :disabled="loading" loader-height="2">
          <v-card-text class="pb-0">
            <div class="d-flex align-center">
              <v-btn
                rounded
                color="primary"
                elevation="0"
               
                class="mr-2"
                @click="addFileConfig()"
                data-testid="file-list-config__add-config-btn"
                ><v-icon class="mr-1">mdi-plus</v-icon><p>Add Config From Master</p></v-btn
              >
              <lb-string
                label="Search"
                outlined
                hidedetails
                v-model="seachList"
                data-testid="file-list-config__search-input"
              ></lb-string>
              <v-spacer></v-spacer>
              <v-chip label class="border-left-error" outlined
                ><span>Disabled</span></v-chip
              >
              <v-btn icon class="ml-2" @click="refreshData()" data-testid="file-list-config__refresh-btn"
                ><v-icon>mdi-refresh</v-icon></v-btn
              >
            </div>
          </v-card-text>
          <v-card-text>
            <lb-datatablenew :headers="headers" :items="searchResult" :enableslot="['action','status']" :loading="loading" data-testid="file-list-config__datatable">
              <template v-slot:status="{ item }">
                 <v-chip label text color="success" v-if="item.status"
                        ><span>Active</span></v-chip
                      >
                      <v-chip label text color="error" v-else
                        ><span>Inactive</span></v-chip
                      >
              </template>
                <template v-slot:action="{ item }">
                  <div class="d-flex justify-start">
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="shadow-off"
                             
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="ViewConfig(item)"
                              data-testid="file-list-config__view-btn"
                            >
                              <v-icon color="">mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>View Config</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                             
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                $nova.gotoLink({ path: 'filelist/config/' + item._id })
                              "
                              data-testid="file-list-config__edit-btn"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Config</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                             
                              v-bind="attrs"
                              v-on="on"
                              @click="deleteConfig(item._id)"
                              data-testid="file-list-config__delete-btn"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete Config</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          content-class="tooltip-bottom"
                          v-if="item.status"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                             
                              color="success"
                              v-bind="attrs"
                              v-on="on"
                              @click="disabledConfig(item._id)"
                            >
                              <v-icon>mdi-check-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Enable</span>
                        </v-tooltip>

                        <v-tooltip bottom content-class="tooltip-bottom" v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                             
                              color="error"
                              v-bind="attrs"
                              v-on="on"
                              @click="enabledConfig(item._id)"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                          </template>
                          <span>Disable</span>
                        </v-tooltip>
                  </div>
                </template>
          </lb-datatablenew>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <ConfigViewDialogV2
      v-if="isV2Config"
      v-model="configViewDialog"
      :config="fileConfigView"
    />
    <ConfigViewDialog
      v-else
      v-model="configViewDialog"
      :config="fileConfigView"
    />
  </div>
</template>

<script>
import ConfigViewDialog from './FileConfig/ConfigViewDialog.vue';
import ConfigViewDialogV2 from './FileConfigV2/ConfigViewDialogV2.vue';

export default {
  components: {
    ConfigViewDialog,
    ConfigViewDialogV2,
  },
  data() {
    return {
      seachList: '',
      fileItems: [],
      totalFile: [],
      loading: true,
      tab: null,
      configViewDialog: false,
      fileConfigView: {},
      formatedData:[],
      headers: [{
					value: "indexno",
					text: "#",
					sortable: false,
					filterable: false,
				},
				{
					value: "file",
					text: "File Name",
					sortable: true,
					filterable: true,
					lock: true,
				},
				{
					value: "ignorerows",
					text: "Ignore Rows",
					sortable: true,
					// filterable: true,
					lock: true,
				},
				{
					value: "ignorecolumns",
					text: "Ignore Columns",
					sortable: true,
					// filterable: true,
					lock: true,
				},
				{
					value: "status",
					text: "Status",
					// sortable: true,
					// filterable: true,
					lock: true,
				},
				{
					value: "action",
					text: "Action",
					sortable: false,
					filterable: false,
				},
			],
    };
  },
  created() {
    this.refreshData();
  },
  props: {
    filelist: {
      type: Array,
      required: false,
      default: ()=>[]
    }
  },
  methods: {
    refreshData() {
      this.loading = true;
      let ndt = {};
      if(this.filelist.length > 0) ndt = {filter: {filelist: this.filelist}};
      this.axios
        .post("/v2/conserve/fileconfig/getformdata", ndt)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.totalFile = dt.data.data;
            return this.axios.post("/v2/conserve/fileconfig/get", ndt);
          } else throw new Error(dt.data.message);
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.fileItems = dt.data.data;
            this.formateData();
            //   let fileDetails = this.totalFile.filter(({ _id: id1 }) =>
            //     this.fileItems.some(({ file: id2 }) => id1 === id2)
            //   );
          } else throw new Error(dt.data.message);
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formateData() {
			let ObjectTemp = {};
			let ArrayTemp = [];
			this.fileItems.forEach((i, k) => {  
				ObjectTemp = {
					_id: i._id,
					indexno: k + 1,
					file: this.fileName(i.file),
					ignorerows: i.ignorerows,
					ignorecolumns: i.ignorecolumns,
					status:i.status,
          columnmap:i.columnmap,
          blankcolumnheaders:i.blankcolumnheaders,
          ignoredcolumns:i.ignoredcolumns,
          keepduplicatecolumns:i.keepduplicatecolumns,
          removeblankrows:i.removeblankrows,
          unusedcolumns:i.unusedcolumns,
          usercolumnmap: i?.usercolumnmap || [],
          version: i.version || 'v1',
          fileTypes: i.fileTypes || [],
          primaryKeys: i.primaryKeys || [],
				}
				ArrayTemp.push(ObjectTemp);
			});
			this.formatedData = ArrayTemp;      
		},
    addFileConfig() {
      this.$nova.gotoLink({ path: 'filelist/config/' });
    },
    ViewConfig(item) {
      this.fileConfigView = item;
      this.configViewDialog = true;
    },
    fileName(id) {
      let filedetils = this.totalFile.find((x) => x._id === id);
      return (filedetils || {}).name;
    },
    deleteConfig(id) {
      this.loading = true;
      this.axios
        .post("/v2/conserve/fileconfig/delete/" + id)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Deleted successfully");
            this.refreshData();
          } else throw new Error(dt.data.message || "Error Delete File Config");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    enabledConfig(id) {
      this.loading = true;
      this.axios
        .post("/v2/conserve/fileconfig/enable/" + id)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Enabled successfully");
            this.refreshData();
          } else throw new Error(dt.data.message || "Error Enable File Config");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    disabledConfig(id) {
      console.log(id);
      this.loading = true;
      this.axios
        .post("/v2/conserve/fileconfig/disable/" + id)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Disabled successfully");
            this.refreshData();
          } else
            throw new Error(dt.data.message || "Error Disable File Config");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    isV2Config() {
      return this.fileConfigView && this.fileConfigView.version === 'v2';
    },
    searchResult() {
      let tempList = this.formatedData;
      if (this.seachList != "" && this.seachList) {
        tempList = tempList.filter((item) => {
          return item.file.toUpperCase().includes(this.seachList.toUpperCase());
        });
      }
      return tempList;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-data-table {
  & td,
  & th {
    border: 1px solid #bbb !important;
  }
}
.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}
.drag-el {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}
</style>

